"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { CheckCircle2 } from "lucide-react";
import { Button } from "./button";

export interface SuccessViewProps {
  title?: string;
  description: string;
  icon?: React.ReactNode;
  buttonLabel?: string;
  onButtonClick?: () => void;
  className?: string;
}

export function SuccessView({
  title = "¡Excelente!",
  description,
  icon,
  buttonLabel,
  onButtonClick,
  className,
}: SuccessViewProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4 py-12",
        className
      )}
    >
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-50 motion-safe:animate-in motion-safe:zoom-in-50 motion-safe:duration-500 dark:bg-emerald-900/30">
        {icon || (
          <CheckCircle2 className="h-10 w-10 text-emerald-600 dark:text-emerald-400" />
        )}
      </div>
      <div className="space-y-2 text-center">
        <h3 className="text-xl font-bold text-slate-900 dark:text-white">
          {title}
        </h3>
        <p className="max-w-sm text-sm text-slate-600 dark:text-zinc-400">
          {description}
        </p>
      </div>
      {buttonLabel && onButtonClick && (
        <Button variant="primary" size="md" onClick={onButtonClick}>
          {buttonLabel}
        </Button>
      )}
    </div>
  );
}
